/* eslint-disable no-nested-ternary */
import { Tooltip } from 'react-tooltip';
import { formatNumber } from 'utils/formats';
import { useTranslate } from 'hooks/useTranslate';

import '../PartnerBook.scss';

function PlanSummaryBeneficiaryMainTable({
  view,
  summary,
  todaySummary,
  names,
  emails,
  cifs,
  isFormatted = true,
  isTodaySummaryVisible = true,
}) {
  const { t } = useTranslate();

  const formatValue = (value) => (isFormatted ? formatNumber(value) : value);

  const calculateTotals = () => {
    const totals = [0, 0, 0, 0];

    Object.keys(summary || {}).forEach((beneficiaryId) => {
      Object.values(summary[beneficiaryId]).forEach((value, index) => {
        totals[index] += Number(value) || 0;
      });
    });

    return totals;
  };

  const totals = calculateTotals();
  const columnKeys = ['assignedUnits', 'vested', 'canceledUnits', 'acquired'];

  return (
    summary && (
      <div className={view === 2 ? 'nk-block' : 'd-none'}>
        <div className="card card-bordered">
          <div className="table-responsive">
            <table
              className="table table-striped-inverse table-compact nk-tb-list nk-tb-ulist border-right "
              id="beneficiarySummaryTable"
            >
              <thead>
                <tr className="nk-tb-item nk-tb-head tb-tnx-head text-center">
                  <th className="nk-tb-col w-200px">{t('Beneficiaries')}</th>
                  <th className="nk-tb-col w-150px">{t('Email')}</th>
                  <th className="nk-tb-col w-150px">{t('CIF')}</th>
                  <th className="nk-tb-col no-break">{t('AssignedUnits')}</th>
                  <th className="nk-tb-col no-break">{t('Vested')}</th>
                  <th className="nk-tb-col no-break">{t('CanceledUnits')}</th>
                  <th className="nk-tb-col no-break">{t('Acquired')}</th>
                </tr>
              </thead>

              <tbody>
                {Object.keys(summary)?.map((beneficiaryId) => (
                  <tr
                    key={`summary-row-${beneficiaryId}`}
                    className="nk-tb-item"
                  >
                    <td
                      id={beneficiaryId}
                      className="nk-tb-col text-left w-200px text-ellipsis border-right"
                    >
                      {names[beneficiaryId]}
                      <Tooltip anchorId={beneficiaryId} place="bottom">
                        {names[beneficiaryId]}
                      </Tooltip>
                    </td>

                    <td className="nk-tb-col text-left w-150px text-ellipsis border-right">
                      {emails[beneficiaryId]}
                    </td>

                    <td className="nk-tb-col text-left w-150px text-ellipsis border-right">
                      {cifs[beneficiaryId]}
                    </td>

                    {Object.entries(summary[beneficiaryId]).map(
                      ([key, value], index) => {
                        const otherValue = todaySummary?.[beneficiaryId]?.[key];

                        return (
                          <td
                            key={key}
                            className={
                              index === 0
                                ? 'nk-tb-col text-right text-ellipsis border-right'
                                : 'nk-tb-col text-right border-right'
                            }
                          >
                            <b>{formatValue(value)}</b>
                            {isTodaySummaryVisible && (
                              <span className="d-block">
                                ({formatValue(otherValue)})
                              </span>
                            )}
                          </td>
                        );
                      }
                    )}
                  </tr>
                ))}
              </tbody>

              {/* Total Row */}
              <tfoot>
                <tr className="nk-tb-item tb-tnx-head fs-11px font-weight-bold border-top">
                  <td className="nk-tb-col text-left w-200px border-right">
                    {t('Total')}
                  </td>
                  <td className="nk-tb-col text-left w-150px border-right">
                    -
                  </td>
                  <td className="nk-tb-col text-left w-150px border-right">
                    -
                  </td>
                  {totals.map((total, index) => (
                    <td
                      key={columnKeys[index]}
                      className="nk-tb-col text-right border-right"
                    >
                      {formatValue(total)}
                    </td>
                  ))}
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    )
  );
}

export default PlanSummaryBeneficiaryMainTable;
